export default __webpack_public_path__ + "static/media/youtube.dd17c5a6.svg";